/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getInvoicePDF } from '../../actions/InvoiceActions';

class PdfCell extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }
  handleClick = () => {
    if (this.props.row.pdf_document_available !== undefined) {
      getInvoicePDF(this.props.dispatch, this.props.row);
    }
  };

  render() {
    const { row } = this.props;
    if(row && row.pdf_document_available && row.pdf_document_available === 'X'){
      return (
        <img
          src={"/images/ic_pdf.png"}
          alt="pdf"
          key={`${'docId_'}${row.document_number_finance}`}
          onClick={this.handleClick}
          role="presentation"
        />);
    } else {
      return (<img
        src={"/images/ic_pdf_disabled.png"}
        alt="pdf"
        key={`${'docId_'}${row.document_number_finance}`}
        onClick={this.handleClick}
        role="presentation"
      />);
    }
  }
}

PdfCell.propTypes = {
  dispatch: PropTypes.func.isRequired,
  row: PropTypes.object.isRequired,
};

export default connect()(PdfCell);
